/**
 * SEO-теги страниц (title, description, Open Graph, canonical).
 * Используются при сборке (seoPages в vite.config.js) и в браузере (components/PageMeta).
 * Страница без записи в PAGES получает общие теги SITE.
 */

export const SITE = {
  url: "https://ruscomtech.ru",
  title: "Рускомтехнологии",
  description: "Рускомтехнологии - Первый российский вендор в сегменте APM",
};

export const PAGES = {
  "/": {
    title: "Российская система мониторинга ИТ | Ключ-АСТРОМ",
    description:
      "Мониторинг и наблюдаемость ИТ-инфраструктуры на базе технологий ИИ. Проактивный мониторинг бизнес-сервисов, аналитика и оптимизация процессов. Более 10 лет на рынке. В реестре ПО.",
  },
  "/apm/infra": {
    title: "Наблюдаемость ИТ-систем на базе ИИ | Ключ-АСТРОМ",
    description:
      "Мониторинг и наблюдаемость it-инфраструктуры: метрики, логи и трассировки, анализ состояния систем и причин сбоев. Observability для ИТ и бизнеса.",
  },
  "/apm/apps": {
    title:
      "Мониторинг производительности приложений: Application Performance Monitoring | Ключ-АСТРОМ",
    description:
      "Система мониторинга приложений на базе ИИ: время отклика, ошибки и использование ресурсов, прогнозирование. Разберитесь, как APM помогает находить узкие места и повышать стабильность сервисов.",
  },
  "/blog/1c-support": {
    title: "Мониторинг работы баз и серверов 1C | Ключ-АСТРОМ",
    description:
      "1С мониторинг в Ключ-АСТРОМ: единый агент мониторинга, базы данных, клиентские приложения, серверы лицензирования. Контроль производительности систем 1С и настройка сбора метрик для поиска причин замедлений.",
  },
  "/apm/network": {
    title: "Система мониторинга сети | Ключ-АСТРОМ",
    description:
      "Мониторинг сетевой инфраструктуры: доступность устройств, пропускная способность, задержки и потери пакетов. Основные показатели и задачи мониторинга сети.",
  },
  "/technologies": {
    title: "Observability и мониторинг работы приложений | Ключ-АСТРОМ",
    description:
      "Комплексная система мониторинга и наблюдаемости состояния приложений. Поиск и устранение причин сбоев в ИТ.",
  },
  "/cenoobrazovanie": {
    title:
      "Лицензирование российской системы мониторинга приложений и инфраструктуры | Ключ-АСТРОМ",
    description:
      "Варианты поставки и лицензируемые компоненты Observability APM платформы мониторинга Ключ-АСТРОМ. Изучите состав решения и уточните стоимость мониторинга для вашей ИТ-среды.",
  },
  "/apm/db": {
    title: "Мониторинг баз данных | Ключ-АСТРОМ",
    description:
      "Какие показатели отслеживать при мониторинге баз данных: время SQL-запросов, нагрузку на CPU, память и диск, доступность и блокировки.",
  },
  "/apm/containers": {
    title: "Мониторинг контейнеров и Kubernetes | Ключ-АСТРОМ",
    description:
      "Мониторинг контейнеров: потребление CPU и памяти, состояние подов, узлов и сервисов Kubernetes. Обеспечение высокого уровня надежности контейнерных приложений.",
  },
  "/apm/devops": {
    title:
      "Мониторинг DevOps: инфраструктура, приложения и CI/CD | Ключ-АСТРОМ",
    description:
      "Автоматическое реагирование, поиск первопричин и ускорение CI/CD-процессов. Повышение производительности программного обеспечения.",
  },
  "/apm/slo": {
    title: "Контроль SLO и роль APM Observability | Ключ-АСТРОМ",
    description:
      "Application Performance Management Observability - централизованный мониторинг всех компонентов. Проактивный мониторинг и идентификация проблем.",
  },
  "/education": {
    title: "Возможности платформы мониторинга приложений | Ключ-АСТРОМ",
    description:
      "Познакомьтесь с задачами системы мониторинга ИТ-инфраструктуры и приложений: доступность сайтов, производительность приложений и мониторинг цифрового опыта.",
  },
  "/supported-technologies": {
    title: "Поддерживаемые технологии и интеграции | Ключ-АСТРОМ",
    description:
      "Каталог поддерживаемых технологий, интеграций и расширений, предоставляемых «Ключ-Астром» и партнерами",
  },
  "/about": {
    title: "Рускомтехнологии — разработчик платформы мониторинга Ключ-АСТРОМ",
    description:
      "«Рускомтехнологии» — первый российский вендор в сегменте APM. Более 10 лет опыта в ИТ-мониторинге. Свыше 30 клиентов.",
  },
  "/cases": {
    title: "Кейсы внедрения системы мониторинга Ключ-АСТРОМ",
    description:
      "Опыт применения системы мониторинга Ключ-АСТРОМ у заказчиков: мониторинг приложений, цифровых сервисов и пользовательского опыта. Изучите задачи проектов и результаты внедрения.",
  },
  "/partners": {
    title: 'Программа сотрудничества с "Рускомтехнологии" и Ключ-АСТРОМ',
    description:
      "Компания «Рускомтехнологии» проводит работу по созданию сети партнеров на территории России, Белоруссии и Казахстана. Узнайте о сотрудничестве с вендором и подайте заявку на участие в программе.",
  },
  "/blog": {
    title: "Блог Ключ-АСТРОМ: APM и наблюдаемость ИТ-систем",
    description:
      "Статьи и новости о мониторинге приложений и ИТ-инфраструктуры: возможности Ключ-АСТРОМ, практические инструкции, наблюдаемость и опыт применения платформы.",
  },
  "/mcp": {
    title: "Модуль MCP: работа ИИ с данными мониторинга | Ключ-АСТРОМ",
    description:
      "От наблюдения к управлению системой на базе ИИ-аналитики. Искусственный интеллект в мониторинге: поиск аномалий и первопричин сбоев, прогнозирование инцидентов, анализ взаимосвязей и автоматизация работы.",
  },
  "/mib": {
    title: "Модуль информационной безопасности | Ключ-АСТРОМ",
    description:
      "Мониторинг уязвимостей: расширение системы мониторинга и добавление контекста безопасности на уровне выполнения кода. Устранение уязвимостей в 12 раз быстрее",
  },
  "/blog/mcp-in-monitoring": {
    title:
      "Искусственный интеллект в мониторинге: что такое Model Context Protocol (MCP), и как он меняет работу с Observability",
    description:
      "Как Model Context Protocol связывает языковые модели с данными наблюдаемости, кодом и документацией. Разбираем роль MCP в анализе состояния ИТ-систем.",
  },
  "/blog/t1-platinum-partner": {
    title: "Т1 — платиновый партнер Рускомтехнологии",
    description:
      "ИТ-холдинг Т1 получил платиновый статус партнера Рускомтехнологии. Он подтверждает глубокую техническую экспертизу команды Т1, успешный опыт реализации проектов на базе платформы «Ключ-АСТРОМ» и готовность сопровождать заказчиков на всех этапах.",
  },
  "/blog/digital-investment-roi": {
    title: "Как медленная работа приложений влияет на бизнес",
    description:
      "Почему замедления приложений снижают отдачу от цифровых инвестиций. Разбираем влияние на бизнес и роль мониторинга и ИИ в обнаружении скрытых потерь.",
  },
  "/blog/routine-to-analytics": {
    title: "Как автоматизировать выгрузку отчетности в ИТ-мониторинге?",
    description:
      "Как автоматизировать выгрузку данных из системы мониторинга для отчетности и анализа инцидентов. Архив со всеми скриптами и подробной инструкцией по их использованию.",
  },
  "/blog/appsec": {
    title: "Безопасность приложений в рантайме: обзор модуля безопасности",
    description:
      "Как модуль безопасности Ключ-АСТРОМ выявляет уязвимости и отслеживает угрозы в работающих приложениях. Обзор подхода к непрерывному контролю рисков в рантайме.",
  },
  "/blog/observility_v_rossii": {
    title:
      "Observability в России: лидерство Ключ-АСТРОМ в российском рейтинге платформ мониторинга",
    description:
      "Российский рынок наблюдаемости в исследовании ТеДо: тренды мониторинга ИТ-систем и место Ключ-АСТРОМ. Обзор результатов исследования, опубликованный в 2025 году.",
  },
  "/blog/auto-metrics-export-google-sheets": {
    title: "Экспорт метрик Ключ-АСТРОМ в Google Sheets",
    description:
      "Как автоматизировать экспорт метрик из Ключ-АСТРОМ в Google Таблицы для анализа и отчетности. Разбираем перенос данных мониторинга в привычный рабочий формат.",
  },
  "/blog/log-enrichment": {
    title: "Что такое обогащение логов в ИТ-мониторинге: опыт Ключ-АСТРОМ",
    description:
      "Использование функционала связи логов с трассировками в Ключ-АСТРОМ позволяет получить глубокое понимание того, как ваше приложение функционирует на каждом этапе.",
  },
  "/blog/session-properties": {
    title:
      "Как глубже анализировать поведение пользователей приложений: опыт Ключ-АСТРОМ",
    description:
      "Как свойства сессий и действий дополняют данные о пользователях веб- и мобильных приложений. Разбираем возможности настройки мониторинга в Ключ-АСТРОМ.",
  },
  "/blog/reestr-os": {
    title: "Ключ-АСТРОМ подтвердил включение в реестр российского ПО",
    description:
      "Ключ-АСТРОМ успешно подтвердил нахождение в реестре российского ПО",
  },
  "/blog/monitoring-releases": {
    title: "Как работает мониторинг релизов в Ключ-АСТРОМ",
    description:
      "Как отслеживать изменения после релиза и находить причины замедлений и ошибок. Практический материал о мониторинге новых версий приложений в системе мониторинга Ключ-АСТРОМ.",
  },
  "/blog/metrics-for-russian-oss": {
    title:
      "Как эффективно контролировать работу российских ОС и минимизировать эксплуатационные риски: опыт Ключ-АСТРОМ.",
    description:
      "Мониторинг российских операционных систем: РЕД ОС, РОСА, Альт Линукс и Astra Linux. Возможности сбора системных метрик. Ключ-Астром – автоматизированный мониторинг для российских ОС",
  },
  "/blog/monitoring-security-apps": {
    title: "Мониторинг событий безопасности в Ключ-АСТРОМ",
    description:
      "Обзор функций мониторинга безопасности Ключ-АСТРОМ: на платформе доступны инструменты сбора и анализа уязвимостей, типов совершенных атак, лог файлов и деталей по обнаруженной атаке",
  },
  "/blog/apm-solution-for-business-it": {
    title: "Вебинар Ключ-АСТРОМ: мониторинг ИТ и кейс МКБ",
    description:
      "Вебинар о стабильности ИТ-инфраструктуры и приложений: интеллектуальный мониторинг Ключ-АСТРОМ, демонстрация платформы и опыт применения в банке МКБ.",
  },
  "/blog/instrument-apm-vs-platform-apm": {
    title: "Что такое инструменты APM и APM-платформа?",
    description:
      "Чем отдельные инструменты мониторинга отличаются от APM-платформы. Разбираем охват стека, анализ причин проблем и преимущества для ИТ-команды и бизнеса.",
  },
  "/blog/monitor-vs-observability": {
    title: "Мониторинг и наблюдаемость: что это такое, в чем отличия и цели",
    description:
      "Чем наблюдаемость отличается от мониторинга, как устроены три столпа и распределенная трассировка. Интеллектуальный мониторинг и автоматизация",
  },
  "/blog/real-users": {
    title: "Мониторинг реальных пользователей: RUM в Ключ-АСТРОМ",
    description:
      "Что показывает мониторинг реальных пользователей: действия, загрузка страниц и качество цифрового опыта. Возможности RUM в Ключ-АСТРОМ для анализа приложений.",
  },
  "/blog/synthetic-monitoring": {
    title: "Синтетический мониторинг: как проверять работу сервисов",
    description:
      "Как синтетический мониторинг имитирует действия пользователей и проверяет доступность приложений. Разбираем подход к тестированию цифровых сервисов.",
  },
  "/blog/session-replay": {
    title: "Мониторинг цифрового опыта пользователя: опыт Ключ-АСТРОМ",
    description:
      "Как воспроизведение пользовательских сессий помогает разбирать ошибки и понимать цифровой опыт. Обзор возможностей воспроизведения сессий на платформе Ключ-АСТРОМ.",
  },
};

/** Теги страницы: [атрибут, имя, поле из getPageMeta] */
export const SEO_META_TAGS = [
  ["name", "description", "description"],
  ["property", "og:title", "title"],
  ["property", "og:description", "description"],
  ["property", "og:url", "url"],
];

export function normalizePath(pathname) {
  return pathname.replace(/\/+$/, "") || "/";
}

/**
 * @param {string | null} pathname null — адрес не из PAGES (spa.html)
 * @returns {{ title: string, description: string, url: string | null }}
 *   url = null — без canonical и og:url, чтобы не склеить страницу с чужим адресом
 */
export function getPageMeta(pathname) {
  const path = pathname == null ? null : normalizePath(pathname);
  const page = path && PAGES[path];
  return {
    title: page ? page.title : SITE.title,
    description: page ? page.description : SITE.description,
    url: page ? SITE.url + path : null,
  };
}

const escapeHtml = (s) =>
  s
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

export function renderSeoHead(meta) {
  const tags = [`<title>${escapeHtml(meta.title)}</title>`];
  for (const [attr, name, field] of SEO_META_TAGS) {
    if (meta[field])
      tags.push(
        `<meta ${attr}="${name}" content="${escapeHtml(meta[field])}" />`,
      );
  }
  if (meta.url)
    tags.push(`<link rel="canonical" href="${escapeHtml(meta.url)}" />`);
  return tags.join("\n    ");
}
